import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const CustomDDLArrowIcon = (props: any) => (
  <KeyboardArrowDownIcon {...props} sx={{ color: "#AAA !important" }} />
);

export default CustomDDLArrowIcon;
